import React from 'react';

import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

const PartialActionsItem = ({ icon, text, onClick }) => {
  return <Dropdown.Item icon={icon} text={text} onClick={onClick} />;
};

PartialActionsItem.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PartialActionsItem;
